import React, { useContext } from 'react';
import { IconButton, Select } from 'uxp/components';
import { QueryBuilderContext } from '@query-builder/QueryBuilderContext';
import './SourceMapper.scss';
export const SourceMapper = ({ conditions, source1, source2, onChange }) => {
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const updateCondition = (index, field, value) => {
        const newConditions = [...conditions];
        newConditions[index] = Object.assign(Object.assign({}, newConditions[index]), { [field]: value });
        onChange(newConditions);
    };
    const addCondition = () => {
        const newConditions = [...conditions, {
                source1: '',
                source2: ''
            }];
        onChange(newConditions);
    };
    const removeCondition = (index) => {
        const newConditions = conditions.filter((_, i) => i !== index);
        onChange(newConditions);
    };
    return React.createElement("div", { className: "lucy-query-engine-source-mapper-cb03f83e" },
        (conditions || []).map((c, i) => React.createElement("div", { key: i, className: "lucy-query-engine-source-mapper-condition-cb03f83e" },
            React.createElement("div", { className: "lucy-query-engine-source-mapper-condition-field-cb03f83e" },
                React.createElement(Select, { selected: c.source1, onChange: s => updateCondition(i, 'source1', s), options: ((source1 === null || source1 === void 0 ? void 0 : source1.schema) || []).map(f => ({
                        label: f.name,
                        value: f.name
                    })), placeholder: $L('lqe.sm.source-01') })),
            React.createElement("div", { className: "lucy-query-engine-source-mapper-condition-field-cb03f83e" },
                React.createElement(Select, { selected: c.source2, onChange: s => updateCondition(i, 'source2', s), options: ((source2 === null || source2 === void 0 ? void 0 : source2.schema) || []).map(f => ({
                        label: f.name,
                        value: f.name
                    })), placeholder: $L('lqe.sm.source-02') })),
            React.createElement("div", { className: "lucy-query-engine-source-mapper-delete-wrap-cb03f83e" },
                React.createElement(IconButton, { type: 'delete', variant: 'danger', onClick: () => removeCondition(i) })))),
        React.createElement("div", { className: "lucy-query-engine-source-mapper__add-btn-cb03f83e", onClick: addCondition }, $L('lqe.sm.add-condition')));
};
export function validateConditions(conditions) {
    const uniqueAttributesSource1 = new Set();
    const uniqueAttributesSource2 = new Set();
    if (!conditions || conditions.length === 0) {
        return {
            isValid: false,
            error: 'lqe.sm.error-no-conditions',
            uniqueAttributesSource1: [],
            uniqueAttributesSource2: []
        };
    }
    for (const condition of conditions) {
        if (!condition.source1 || !condition.source2) {
            return {
                isValid: false,
                error: 'lqe.sm.error-incomplete',
                uniqueAttributesSource1: [],
                uniqueAttributesSource2: []
            };
        }
        uniqueAttributesSource1.add(condition.source1);
        uniqueAttributesSource2.add(condition.source2);
    }
    return {
        isValid: true,
        error: null,
        uniqueAttributesSource1: Array.from(uniqueAttributesSource1),
        uniqueAttributesSource2: Array.from(uniqueAttributesSource2)
    };
}
